export enum FrequencyTypes {
  daily = "daily",
  weekly = "weekly",
  monthly = "monthly",
  fortnightly = "fortnightly",
}

export const FrequencyTypeLabels: Record<FrequencyTypes, string> = {
  [FrequencyTypes.daily]: "Diária",
  [FrequencyTypes.weekly]: "Semanal",
  [FrequencyTypes.fortnightly]: "Quinzenal",
  [FrequencyTypes.monthly]: "Mensal",
};

export const FrequencyTypePluralLabels: Record<FrequencyTypes, string> = {
  [FrequencyTypes.daily]: "diárias",
  [FrequencyTypes.weekly]: "semanais",
  [FrequencyTypes.fortnightly]: "quinzenais",
  [FrequencyTypes.monthly]: "mensais",
};
